import useApiController from "@hooks/useApiController";

export default function useUserController(): Admin.Controllers.Customer {
    const { index } = useApiController('/api/admin/customers')
    return { index }
}